// Dedicated icon hub for the public Profile bundle.
// Kept separate from Ui/icons.tsx so the Profile chunk does not embark
// the ~150 SVGs needed only by the Admin/Dashboard side.
import AccountTriggerIcon from '../../assets/images/icons/circle-user-light-full.svg?react';
import AddToHomeScreenIcon from '../../assets/images/icons/mobile-screen-button-light-full.svg?react';
import AirplaneOfflineIcon from '../../assets/images/icons/plane-light-full.svg?react';
import BuyIcon from '../../assets/images/icons/cart-shopping-light-full.svg?react';
import CheckCircleIcon from '../../assets/images/icons/circle-check-light-full.svg?react';
import CloseIcon from '../../assets/images/icons/xmark-light-full.svg?react';
import ExchangeIcon from '../../assets/images/icons/rotate-light-full.svg?react';
import LinkExternalIcon from '../../assets/images/icons/link-external-light-full.svg?react';
import MenuBarsIcon from '../../assets/images/icons/bars-light-full.svg?react';
import RefreshIcon from '../../assets/images/icons/rotate-right-light-full.svg?react';
import SendIcon from '../../assets/images/icons/paper-plane-top-light-full.svg?react';
import ShareProfileIcon from '../../assets/images/icons/share-light-full.svg?react';
import VcardIcon from '../../assets/images/icons/address-card-light-full.svg?react';
import {createIconComponent} from '../Ui/createIconComponent';

export const icons = {
    accountTrigger: createIconComponent(AccountTriggerIcon),
    addToHomeScreen: createIconComponent(AddToHomeScreenIcon),
    airplaneOffline: createIconComponent(AirplaneOfflineIcon),
    buy: createIconComponent(BuyIcon),
    checkCircle: createIconComponent(CheckCircleIcon),
    close: createIconComponent(CloseIcon),
    exchange: createIconComponent(ExchangeIcon),
    linkExternal: createIconComponent(LinkExternalIcon),
    menuBars: createIconComponent(MenuBarsIcon),
    refresh: createIconComponent(RefreshIcon),
    send: createIconComponent(SendIcon),
    shareProfile: createIconComponent(ShareProfileIcon),
    vcard: createIconComponent(VcardIcon),
};
